import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { UserI } from '@/pages/Status/Login/interface/UserInterface.interface';

interface UserState {
  isAuth: boolean;
  user: UserI | null;
}

interface UserActions {
  setUser: (user: UserI) => void;
  clearUser: () => void;
}

export type UserStore = UserState & UserActions;

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      // State
      isAuth: false,
      user: null,

      // Actions
      setUser: (user: UserI) =>
        set({
          user,
          isAuth: true,
        }),

      clearUser: () =>
        set({
          user: null,
          isAuth: false,
        }),
    }),
    {
      name: 'user-store',
      partialize: (state) => ({
        user: state.user,
        isAuth: state.isAuth,
      }),
    },
  ),
);
